<div class="modal-header">
  <h4 class="modal-title">Signaler un Bug</h4>
  <dismiss (click)="activeModal.dismiss('Cross click')"></dismiss>
</div>

<div class="modal-body">

      <globalForms
        [data]="development"
        [columns]="columns"
        [form]="form"
        (sendDatas)="saveObject($event)"
        [folder]="folder"
        [back]="['/DEVnet', 'developments']"
      >
      </globalForms>
</div>
